import React from 'react';
import FJPlayIcon from '../../../../assets/svg/play(1).svg?react';
import classNames from 'classnames';
import styles from './FJPlayBtn.module.less';

const FJPlayBtn = props => {
    const { className, style, onClick } = props;

    return (
        <div className={classNames(styles.box, className)} style={style} onClick={onClick}>
            <FJPlayIcon />
        </div>
    );
};

export default FJPlayBtn;
